import React from "react";
import VmoButton from "../Elements/VmoButton/VmoButton";
import VmoDropdown from "../Modules/Dropdown/VmoDropdown";
import VmoDropdownItem from "../Modules/Dropdown/VmoDropdownItem";
import VmoDropdownMenu from "../Modules/Dropdown/VmoDropdownMenu";
import VmoHeader from "../Elements/VmoHeader/VmoHeader";
import VmoHeaderContent from "../Elements/VmoHeader/VmoHeaderContent";
import VmoHeaderSubheader from "../Elements/VmoHeader/VmoHeaderSubheader";
import VmoIcon from "../Elements/VmoIcon/VmoIcon";
import VmoTooltip from "../Custom/VmoTooltip";
import PropTypes from "prop-types";
import { FiCheck, FiFilePlus } from "react-icons/fi";
import CreateFirstSvg from "../../assets/CreateFirstSvg";

/**
 * @component
 * @example
 * <VmoCreateFirst header='Create User' subHeader='user'  />
 */

function VmoCreateFirst({
  header,
  subHeader,
  inlineStyle,
  imageSrc,
  headerIcon,
  items,
  primaryButtonProps,
  secondaryButtonProps,
}) {
  const renderPrimaryButton = () => {
    const {
      tooltipContent,
      buttonText,
      disable,
      onClick,
      tooltip,
      type,
      dropdownOptions,
    } = primaryButtonProps;

    const renderTooltipButton = () => (
      <VmoTooltip
        size="mini"
        position="top"
        content={tooltipContent}
        trigger={
          <VmoButton
            style={{ opacity: 0.45 }}
            className="add-first-btn cf-primary-btn"
          >
            {buttonText}
          </VmoButton>
        }
      />
    );

    const renderButton = () => (
      <VmoButton
        onClick={onClick}
        disabled={disable}
        className="add-first-btn cf-primary-btn"
      >
        {buttonText}
      </VmoButton>
    );

    const renderDropdownButton = () => (
      <VmoDropdown
        disabled={disable}
        button
        className="cf-primary-btn createFirstDropdown mr-3"
        text={buttonText}
      >
        <VmoDropdownMenu className="creCampgDd">
          {dropdownOptions.map(
            ({ Icon, image, header, subHeader, value }, index) => (
              <VmoDropdownItem
                value={value}
                key={index}
                onClick={() => onClick(value)}
              >
                <div className="cmpIcon">
                  {Icon ? <Icon /> : null}
                  {image ? (
                    <img width={25} height={25} src={image} alt="value" />
                  ) : null}
                </div>
                <div className="cmpContent">
                  <h5>{header}</h5>
                  <p className="m-0">{subHeader}</p>
                </div>
              </VmoDropdownItem>
            )
          )}
        </VmoDropdownMenu>
      </VmoDropdown>
    );

    return tooltip
      ? renderTooltipButton()
      : type === "dropdown"
      ? renderDropdownButton()
      : renderButton();
  };

  const renderSecondaryButton = () => {
    const { onClick, text } = secondaryButtonProps;
    return (
      <VmoButton basic onClick={onClick} className="learn-more-btn">
        {text}
      </VmoButton>
    );
  };

  return (
    <div className="set-empty" style={inlineStyle}>
      <div className="info-content">
        <div className="info-content-header">
          {headerIcon || <FiFilePlus />}
          <h2>{header}</h2>
        </div>
        <p>{subHeader}</p>
        {items?.map((item, index) => {
          return (
            <VmoHeader key={index} as="h2">
              <VmoIcon>{item?.icon ? item?.icon : <FiCheck />}</VmoIcon>
              <VmoHeaderContent>
                {item.header}
                <VmoHeaderSubheader>{item.subHeader}</VmoHeaderSubheader>
              </VmoHeaderContent>
            </VmoHeader>
          );
        })}
        {renderPrimaryButton()}
        {renderSecondaryButton()}
      </div>
      <div className="img">
        {imageSrc ? (
          <img style={{ maxWidth: 330 }} src={imageSrc} />
        ) : (
          CreateFirstSvg()
        )}
      </div>
    </div>
  );
}

export default VmoCreateFirst;

VmoCreateFirst.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
  inlineStyle: PropTypes.object,
  imageSrc: PropTypes.string,
  headerIcon: PropTypes.element,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      subHeader: PropTypes.string.isRequired,
      icon: PropTypes.element,
    })
  ),
  primaryButtonProps: PropTypes.shape({
    type: PropTypes.oneOf(["dropdown", "button"]).isRequired,
    buttonText: PropTypes.string,
    dropdownOptions: PropTypes.arrayOf(
      PropTypes.shape({
        Icon: PropTypes.element.isRequired,
        header: PropTypes.string.isRequired,
        subHeader: PropTypes.string.isRequired,
        image: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
      })
    ),
  }),
  secondaryButtonProps: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

VmoCreateFirst.defaultProps = {
  header: "Create",
  subHeader: "",
  inlineStyle: {},
  imageSrc: "",
  headerIcon: null,
  items: [],
  primaryButtonProps: {
    type: "button",
    buttonText: "Add",
    dropdownOptions: [],
    disable: false,
    onClick: () => null,
    tooltip: false,
    tooltipContent: "",
  },
  secondaryButtonProps: {
    text: "Learn more",
    onClick: () => null,
  },
};
